// This file is auto-generated by ./bin/rails stimulus:manifest:update
import Copy from "./copy_controller"
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AnswerController from "./answer_controller.js"
import DropdownController from "./dropdown_controller.js"
import ExamResultForm from "./exam-result-form_controller.js"
import Exercise from "./exercise_controller.js"
import FilterBadge from "./filter-badge_controller.js"
import Image from "./image_controller.js"
import InstallBanner from "./install-banner_controller.js"
import PwaReinstall from "./pwa-reinstall_controller.js"
import ReportDiagnostics from "./report-diagnostics_controller.js"
import Modal from "../modal_controller.js"
import Loader from "../loader_controller.js"
import FlashController from "../flash_controller"
import CheckoutRedirect from "../checkout_redirect_controller.js"
import RedirectButtonDropdown from "./redirect-button-dropdown_controller.js"
import RemoteForm from "./remote-form_controller.js"
import ServiceWorker from "../service_worker_controller.js"
import Sidebar from "./sidebar_controller.js"
import ListFilter from "./list-filter_controller.js"
import Solution from "./solution_controller.js"
import Tabs from "./tabs_controller.js"
import OutsideModalTrigger from "./outside-modal-trigger_controller.js"
import UnsavedChanges from "./unsaved-changes_controller.js"
import Purchase from "./purchase_controller.js"
import Oauth from "./oauth_controller.js"
import Space from "./space_controller.js"
import Countdown from "./countdown_controller.js"
import PracticalOrdering from "./practical-ordering_controller.js"
import CodeEditor from "./code-editor_controller.js"
import CodeLoading from "./code-loading_controller.js"
import CostTable from "./cost-table_controller.js"
import Share from "./share_controller.js"
import Dismissible from "./dismissible_controller.js"
import NicknameSuggestion from "./nickname-suggestion_controller.js"
import Avatar from "./avatar_controller.js"
import AvatarPicker from "./avatar-picker_controller.js"
import ConfirmModal from "../confirm_modal_controller.js"
import Carousel from "./carousel_controller.js"
import FileInput from "../edu/file_input_controller"
import Sortable from "../edu/sortable_controller"
import GenerationSteps from "./generation_steps_controller"
import Flashcard from "./flashcard_controller"

application.register("answer", AnswerController)
application.register("dropdown", DropdownController)
application.register("exam-result-form", ExamResultForm)
application.register("exercise", Exercise)
application.register("filter-badge", FilterBadge)
application.register("flash", FlashController)
application.register("image", Image)
application.register("report-diagnostics", ReportDiagnostics)
application.register("install-banner", InstallBanner)
application.register("pwa-reinstall", PwaReinstall)
application.register("modal", Modal)
application.register("loader", Loader)
application.register("checkout-redirect", CheckoutRedirect)
application.register("redirect-button-dropdown", RedirectButtonDropdown)
application.register("remote-form", RemoteForm)
application.register("service-worker", ServiceWorker)
application.register("sidebar", Sidebar)
application.register("list-filter", ListFilter)
application.register("solution", Solution)
application.register("tabs", Tabs)
application.register("outside-modal-trigger", OutsideModalTrigger)
application.register("unsaved-changes", UnsavedChanges)
application.register("purchase", Purchase)
application.register("countdown", Countdown)
application.register("oauth", Oauth)
application.register("space", Space)
application.register("practical-ordering", PracticalOrdering)
application.register("code-editor", CodeEditor)
application.register("code-loading", CodeLoading)
application.register("cost-table", CostTable)
application.register("share", Share)
application.register("dismissible", Dismissible)
application.register("nickname-suggestion", NicknameSuggestion)
application.register("avatar", Avatar)
application.register("avatar-picker", AvatarPicker)
application.register("confirm-modal", ConfirmModal)
application.register("carousel", Carousel)
application.register("copy", Copy)
application.register("file-input", FileInput)
application.register("sortable", Sortable)
application.register("generation-steps", GenerationSteps)
application.register("flashcard", Flashcard)
